<template lang="html">
    <div class="">
  
    <div class="creategroup layout-page" :style="stylechat" v-if="step === 1 || step === 3">
      <v-overlay :value="progress">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
        >
        <!-- @click="routePage('/homepage')"
          <v-icon class="fz-30">mdi-chevron-left</v-icon> -->
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title" v-if="step === 1">{{$t('Dialog.group.chooseFriend')}}</span>
          <span class="tab-title" v-if="step === 3">{{$t('Dialog.group.addMember')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
        >
          <v-btn
            text
            :disabled="selected.length === 0"
            :class="selected.length !== 0 ? 'btn-color' : 'btn-color-dis'"
            @click="toStep(2)"
            v-if="step === 1"
          >
            {{$t('Task.allTask.next')}}
          </v-btn>
          <v-btn
            text
            :disabled="selected.length === 0"
            :class="selected.length !== 0 ? 'btn-color' : 'btn-color-dis'"
            @click="toStep(2)"
            v-if="step === 3"
          >
            {{$t('AnswerQuestion.ok')}}
          </v-btn>
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout row wrap justify-start align-center class="pt-4 pl-5 pr-5 pb-5">
        <v-text-field
          ref="search"
          v-model="search"
          :placeholder="$t('LeftSide.addFiend.searching')"
          prepend-inner-icon="mdi-magnify"
          solo
          dense
          hide-details
          clearable
        ></v-text-field>
      </v-layout>
      <div :class="selected.length !== 0 ? 'layout-listfriend-select' : 'layout-listfriend'">
        <!-- list friend -->
        <v-list v-if="listfriend.length !== 0">
          <!-- <v-list-item-group multiple> -->
            <template v-for="(item, index) in FilterListfriend">
              <v-list-item
                :key="item.tokenuser"
              >
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-avatar>
                    <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                    <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                    <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name" class="text-overflow">
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action class="pb-2">
                    <!-- radio -->
                    <!-- <v-checkbox
                      :input-value="active"
                      :true-value="item"
                      class="checkbox-color"
                      @click="toggle"
                    ></v-checkbox> -->
                    <v-checkbox v-model="selected" :value="item" class="checkbox-color">
                    </v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
              <v-divider
                v-if="index < FilterListfriend.length - 1"
                :key="index"
              ></v-divider>
            </template>
          <!-- </v-list-item-group> -->
        </v-list>
      </div>
  
      <div v-if="selected.length !== 0" class="pa-2">
        <span class="pl-2 pt-2">{{$t('LeftSide.friend.haveMember', { count: selected.length }) }}</span>
        <v-row justify="space-around">
          <v-col
            cols="12"
            sm="10"
            md="8"
          >
            <v-sheet
              elevation="10"
              class="px-1"
            >
              <v-chip-group
                active-class=""
              >
                <v-chip
                  v-for="(tag, i) in selected"
                  :key="i"
                  close
                  @click:close="removeListAddGroup(tag)"
                >
                <v-avatar>
                  <img v-if="tag.profilepicture" :src="tag.profilepicture" :alt="tag.name" class="img-position">
                  <img v-else-if="tag.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" class="img-position" :alt="tag.name">
                  <img v-else-if="tag.type === 'government'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" class="img-position" :alt="tag.name">
                  <img v-else-if="tag.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="img-position" :alt="tag.name">
                  <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="img-position" :alt="tag.name">
                </v-avatar>
                <span class="text-overflow-badge">{{tag.name}}</span>
                </v-chip>
              </v-chip-group>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
    </div>
  
    <div class="creategroup layout-page" :style="stylechat" v-if="step === 2">
      <v-overlay :value="progress">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
          @click="toStep(1)"
        >
          <v-icon class="fz-30">mdi-chevron-left</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title">{{$t('LeftSide.createGroup.header')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pa-0"
        >
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout row wrap justify-end align-center class="pt-4 pl-5 pr-5 pb-5">
        <v-badge
          avatar
          bordered
          overlap
          bottom
          offset-x="25"
          offset-y="25"
        >
          <template v-slot:badge>
            <v-avatar>
              <v-icon>mdi-camera</v-icon>
              <div style="display: none;">
                <input class="CSChatThai" type="file" name="file1" @change="previewImageweb" accept="image/*" id="uploadpicgroupweb" />
              </div>
            </v-avatar>
          </template>
  
          <v-avatar size="100" style="border-style: solid; border-width: thin; border-color: #e2e1e3;">
            <img :src="`${publicPath}/assets/img/default_profile/group-white.png`" class="img-position" style="cursor: pointer; width: 130px;height: 130px;"  v-if="imageData == ''" @click="uppic">
            <img :src="imageData" class="img-position" @click="uppic" v-else style="cursor: pointer; width: 130px;height: 130px;" >
            <div style="display: none;">
              <input class="CSChatThai" type="file" name="file1" @change="previewImageweb" accept="image/*" id="uploadpicgroupweb" />
            </div>
          </v-avatar>
        </v-badge>
        <v-textarea
            class="ml-3"
            solo
            no-resize
            rows="2"
            row-height="3"
            ref="search"
            v-model="groupName"
            :placeholder="$t('LeftSide.createGroup.detailSearch')"
            dense
            counter="50"
            maxlength="50"
          ></v-textarea>
      </v-layout>
      <v-divider class="ma-2"></v-divider>
      <v-layout row wrap justify-start align-center class="ma-3" @click="toStep(3)">
        <v-icon class="fz-30 checkbox-color">mdi-plus-circle</v-icon>
        <span class="checkbox-color ml-2">{{$t('Dialog.group.addMember')}}</span>
      </v-layout>
      <div :class="selected.length !== 0 ? 'layout-listfriend-select-step-2' : 'layout-listfriend-step-2'">
        <!-- list friend -->
        <v-list v-if="selected.length !== 0">
          <v-subheader>{{$t('LeftSide.friend.haveMember', { count: selected.length + 1 }) }}</v-subheader>
          <!-- ui user in list member group -->
          <v-list-item>
            <template v-slot:default="{ active, toggle }">
              <v-list-item-avatar>
                <v-img v-if="data_user.profilepicture" :src="data_user.profilepicture" class="img-position"></v-img>
                <img v-else-if="data_user.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                <img v-else-if="data_user.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="data_user.name" class="text-overflow">
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
          <!-- <v-list-item-group multiple> -->
            <template v-for="(item, index) in selected">
              <v-list-item
                :key="item.tokenuser"
              >
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-avatar>
                    <v-img v-if="item.profilepicture" :src="item.profilepicture" class="img-position"></v-img>
                    <img v-else-if="item.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" alt="" class="img-position">
                    <img v-else-if="item.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" alt="" class="img-position">
                    <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name" class="text-overflow">
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action class="pb-2">
                    <!-- radio -->
                    <!-- <v-checkbox
                      :input-value="active"
                      :true-value="item"
                      class="checkbox-color"
                      @click="toggle"
                    ></v-checkbox> -->
                    <v-checkbox v-model="selected" :value="item" class="checkbox-color">
                    </v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
              <v-divider
                v-if="index < selected.length - 1"
                :key="index"
              ></v-divider>
            </template>
          <!-- </v-list-item-group> -->
        </v-list>
      </div>
  
      <div class="pa-2">
        <v-btn @click="createGroup()" class="btn-confirm" block :disabled="!(selected.length !== 0 && groupName !== '' && groupName !== null)">{{$t('AnswerQuestion.createGroup')}}</v-btn>
      </div>
    </div>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
  </div>
  
  </template>
  
  <script>
  import { sync } from 'vuex-pathify'
  import ErrorAlert from '@/components/Alert/Error'
  
  var _ = require('lodash')
  export default {
    data () {
      return {
        publicPath: process.env.VUE_APP_BASE_PATH,
        ErrorDialog: false,
        ErrorDialogDetail: {},
        imageData: '',
        groupName: '',
        step: 1,
        selected: [],
        search: '',
        stylechat: {
          "--CreatedGroup-HeaderColor": "white",
          "--CreatedGroup-TabBackground": "white",
          "--CreatedGroup-Icon": "gray",
          "--CreatedGroup-IconActive": "#2662ae",
          "--CreatedGroup-Background": "white",
          "--CreatedGroup-FontSize": "18px",
          "--CreatedGroup-FontColor": "back",
          "--CreatedGroup-FontSize-Status": "16px",
          "--CreatedGroup-FontColor-Status": "grey",
          "--CreatedGroup-Background-Input": "#E2E1E3",
          "--CreatedGroup-Color-Button": "#EFF2FE",
          "--CreatedGroup-FontColor-Button": "#2662ae",
          "--CreatedGroup-FontColor-Block-Button": "#cb1002",
          "--CreatedGroup-FontColor-Dis-Button": "#e2e1e3",
          "--CreatedGroup-Btn-Confirm-Background": "#2662ae",
          "--CreatedGroup-Btn-Confirm-Color": "white",
          "--CreatedGroup-Btn-Confirm-FontSize": "18px",
        },
        listfriend: [],
        data_user: {},
        progress: false,
        selectFile: '',
      }
    },
    components: {
      ErrorAlert
    },
    computed: {
      FilterListfriend () {
        if (this.search !== '' && this.search !== null) {
          return this.listfriend.filter(post => {
            return post.name.toLowerCase().includes(this.search.toLowerCase())
          })
        } else {
          return this.listfriend
        }
      },
      ...sync('*')
    },
    watch: {
      selected () {
        if (this.selected.length !== 0) {
          // this.selected = _.filter(this.selected, function(o) { return o.tokenuser !== undefined })
          // this.selected = _.unionBy(this.selected, 'tokenuser')
          // console.log(this.selected)
        }
      }
    },
    created () {
      // console.log('themechat group', this.themechat)
      // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
      var user_profile = ''
      if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
      } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
      }
      this.data_user = user_profile['account']['profile']
      // console.log(this.data_user)
      this.getListFriend(this.data_user.tokenuser)
    },
    methods: {
      closeAlertDialog (data) {
        // console.log(data)
        if (data.type === 'warning') {
          // this.WarningDialog = data.value
        } else if (data.type === 'err') {
          this.ErrorDialog = data.value
        }
      },
      createGroup () {
        // console.log(_.map(this.selected, 'tokenuser'))
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/create-group`, {
          tokenuser: this.data_user.tokenuser,
          listmember: _.map(this.selected, 'tokenuser'),
          group_name: this.groupName
        }).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            if (this.selectFile !== '') {
              var uploadFile = new FormData()
              uploadFile.append('file', this.selectFile, this.selectFile.name)
              uploadFile.append('group_id', response.data.group.group_id)
              uploadFile.append('tokenuser', this.data_user.tokenuser)
              this.axios.post(process.env.VUE_APP_API_MANAGE + '/setimagegroup', uploadFile).then((responsed) => {
                if (responsed.data.status === 'success') {
                  // this.$swal(
                  //   this.$t('Alert.Success.createGroup'),
                  //   '',
                  //   'success')
                  this.selectFile = ''
                  this.imageData = ''
                  this.selected = []
                  document.getElementById('uploadpicgroupweb').value = ''
                  this.progress = false
                }
                this.$router.push(`/chat-web/${response.data.group.tokenroom}`)
              }).catch(err => {
                console.log(err)
                this.progress = false
                this.ErrorDialogDetail = {
                  title: 'Error',
                  text: this.$t('Alert.Fail.default.somethingWrong')
                }
                this.ErrorDialog = true
              })
            } else {
              this.selectFile = ''
              this.imageData = ''
              this.selected = []
              document.getElementById('uploadpicgroupweb').value = ''
              this.progress = false
              // this.$router.push('/web')
              this.$router.push(`/chat-web/${response.data.group.tokenroom}`)
            }
          }
        }).catch(err => {
          console.log(err)
          this.selectFile = ''
          this.imageData = ''
          this.selected = []
          document.getElementById('uploadpicgroupweb').value = ''
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      },
      uppic () {
        // $('#uploadpicgroupweb').click()
        document.getElementById('uploadpicgroupweb').click()
      },
      previewImageweb (data) {
        var input = data.target
        this.selectFile = data.target.files[0]
        if (input.files && input.files[0]) {
          var reader = new FileReader()
          reader.onload = (e) => {
            this.imageData = e.target.result
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      toStep (key) {
        this.step = key
      },
      removeListAddGroup (item) {
        // console.log(item)
        this.selected.splice(this.selected.indexOf(item), 1)
      },
      getListFriend (token) {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_GO + `/v1/get-list-friend`, {
          tokenuser: token
        }).then((response) => {
          if (response.data.status === 'success') {
            this.progress = false
            this.listfriend = response.data['list_friend']
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          this.listfriend = []
        })
      },
      toggle () {
        console.log('toggle')
      },
      // toggle (item, index) {
      //   console.log(item)
      //   console.log(index)
      //   this.selected.push(item)
      //   this.selected = _.filter(this.selected, function(o) { return o.tokenuser !== undefined })
      //   this.selected = _.unionBy(this.selected, 'tokenuser')
      //   this.list_selected = this.selected
      //   console.log(this.list_selected)
      // },
      // toggle (item, index) {
      //   console.log(item)
      //   console.log(index)
      //   var index_active = ''
      //   var index_company = ''
      //   if (this.selected.includes(this.listfriend[index])) {
      //     console.log('obj1')
      //     index_active = _.findIndex(this.selected, function(o) { return o.tokenuser == item.tokenuser })
      //     this.selected.splice(index_active, 1)
      //   } else if (this.selected.includes(this.listfriend[index])) {
      //     console.log('obj2')
      //     index_company = _.findIndex(this.selected, function(o) { return o.tokenuser == item.tokenuser })
      //     this.selected.splice(index_company, 1)
      //   } else {
      //     console.log('obj3')
      //     if (this.selected.includes(this.listfriend[index]) === false) {
      //       var indexcom = _.findIndex(this.listfriend, function(o) { return o.tokenuser == item.tokenuser })
      //       console.log(indexcom)
      //       if (indexcom !== -1) {
      //         console.log('obj4')
      //         this.selected.splice(indexcom, 1)
      //         this.selected.push(item)
      //         this.selected.includes(this.listfriend[indexcom])
      //       } else {
      //         console.log('obj5')
      //         this.selected.push(this.listfriend[indexcom])
      //         this.selected = _.unionBy(this.selected, 'tokenuser')
      //       }
      //     } else {
      //       console.log('obj6')
      //       this.selected.push(this.listfriend[index])
      //       this.selected = _.unionBy(this.selected, 'tokenuser')
      //     }
      //   }
      // },
      routePage (path) {
        this.$router.push(path)
      },
      closeSelect (item, index) {
        // console.log(item)
        this.selected.splice(this.selected.indexOf(index), 1)
      }
    }
  }
  </script>
  
  <style lang="css" scoped>
  .EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
  }
  .SettingImgWrap {
    display: inline-block;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    margin-top: 20px;
  }
  .SettingImgBtn {
      display: block;
      overflow: hidden;
      position: absolute;
      bottom: -20px;
      right: -20px;
      line-height: 1;
      width: 40px;
      height: 30px;
      bottom: 0;
      left: 0;
      line-height: 30px;
      width: 100%;
      text-align: center;
      cursor: pointer;
      color: #fff;
      background: rgba(0, 0, 0, .5);
  }
  
  .SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
  }
  .btn-confirm {
    background-color: var(--CreatedGroup-Btn-Confirm-Background) !important;
    color: var(--CreatedGroup-Btn-Confirm-Color) !important;
    font-size: var(--CreatedGroup-Btn-Confirm-FontSize) !important;
    font-weight: 600;
    text-transform: none !important;
    border-radius: 10px !important;
  }
  >>>.v-application .elevation-10 {
    box-shadow: none !important;
  }
  >>>.theme--light.v-sheet {
    box-shadow: none !important;
  }
  .layout-select {
    /* height: 100px !important; */
    background-color: var(--CreatedGroup-Background) !important;
  }
  .row-scroll {
    width: 100% !important;
    overflow-x: auto !important;
    /* background-color: bisque; */
    /* width: 100% !important; */
  }
  .row-scroll::-webkit-scrollbar {
    width: 8px;
    height: 4px;
  }
  
  .row-scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  .checkbox-color {
    color: var(--CreatedGroup-IconActive) !important;
  }
  .btn-color {
    color: var(--CreatedGroup-FontColor-Button) !important;
    text-transform: none !important;
    border-radius: 10px !important;
    /* min-width: 125px !important; */
  }
  .btn-color-dis {
    color: var(--CreatedGroup-FontColor-Dis-Button) !important;
    text-transform: none !important;
    border-radius: 10px !important;
    /* min-width: 125px !important; */
  }
  .btn-color-block {
    color: var(--CreatedGroup-FontColor-Block-Button) !important;
    text-transform: none !important;
    border-radius: 10px !important;
    min-width: 125px !important;
  }
  .icon-color {
    color: var(--CreatedGroup-IconActive) !important;
  }
  .fz-18 {
    font-size: 18px !important;
  }
  .fz-20 {
    font-size: 20px !important;
  }
  .fz-30 {
    font-size: 30px !important;
  }
  .layout-listfriend-select {
    height: calc(100vh - 210px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
  }
  
  .layout-listfriend-select::-webkit-scrollbar {
    width: 4px;
  }
  
  .layout-listfriend-select::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  
  .layout-listfriend-select-step-2 {
    height: calc(100vh - 290px) !important;
    overflow-y: auto;
    width: 100% !important;
  }
  .layout-listfriend-select-step-2::-webkit-scrollbar {
    width: 4px;
  }
  
  .layout-listfriend-select-step-2::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  
  .layout-listfriend-step-2 {
    height: calc(100vh - 290px) !important;
    overflow-y: auto;
    width: 100% !important;
  }
  .layout-listfriend-step-2::-webkit-scrollbar {
    width: 4px;
  }
  
  .layout-listfriend-step-2::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  
  .layout-listfriend {
    height: calc(100vh - 106px) !important;
    overflow-y: auto;
    /* background-color: bisque; */
    width: 100% !important;
  }
  .layout-listfriend::-webkit-scrollbar {
    width: 4px;
  }
  
  .layout-listfriend::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0, 0, 0, .1);
  }
  >>>.pull-down-container {
    /* padding: 0px !important; */
    /* overflow-y: hidden !important; */
    height: unset !important;
    max-height: unset !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }
  >>>.pull-down-container::-webkit-scrollbar {
    height: 10px;
    width: 0px;
  }
  >>>.pull-down-header {
    width: 100%;
    height: 0px;
    overflow: hidden;
    position: relative;
    background-color: var(--CreatedGroup-Background) !important;
  }
  >>>.pull-down-content {
    position: absolute;
    max-width: 90%;
    bottom: 10px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    height: 40px;
    color: #0054ad;
    text-align: center;
    border-left: 20px solid transparent;
    font-family: "noto-thin", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
  }
  .tab-title {
    color: var(--CreatedGroup-FontColor) !important;
    font-size: var(--CreatedGroup-FontSize) !important;
    font-weight: 600;
  }
  .tab-title-status {
    color: var(--CreatedGroup-FontColor-Status) !important;
    font-size: var(--CreatedGroup-FontSize-Status) !important;
  }
  .text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 70vw;
  }
  .text-overflow-badge {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 10vw;
  }
  .img-position {
    object-fit: cover;
    object-position: 50% 0;
    border-style: solid;
    border-width: thin;
    border-color: #e8e8e8;
  }
  /* >>>.v-input__slot {
    background-color: var(--CreatedGroup-Background-Input) !important;
    border-radius: 10px !important;
  } */
  >>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: none !important;
    background-color: var(--CreatedGroup-Background-Input) !important;
    border-radius: 10px !important;
  }
  .tab-title {
    color: var(--CreatedGroup-FontColor) !important;
    font-size: var(--CreatedGroup-FontSize) !important;
    font-weight: 600;
  }
  .span-color {
    color: var(--CreatedGroup-FontColor) !important;
    font-size: var(--CreatedGroup-FontSize) !important;
  }
  .layout-page {
    height: 100vh !important;
    overflow: hidden !important;
    background-color: var(--CreatedGroup-Background) !important;
  }
  </style>
  